import React from 'react';
import PropTypes from 'prop-types';
import { injectStripe } from 'react-stripe-elements';
import { Form, FormGroup, Label, Input, Row } from 'reactstrap';
import * as types from 'types';

import { Button }  from 'components';
import FormError, { FormFieldError } from 'components/stateless/FormError';
import Log from 'services/log';

import { BoldSpan } from './styles';

const GiftPrice = props => {
  return (
    <BoldSpan>${props.price} USD</BoldSpan>
  );
};

GiftPrice.propTypes = {
  price: PropTypes.number.isRequired,
};

// see https://github.com/stripe/react-stripe-elements

/*
HJKU-6K56-F4UQ
HK62-LL5T-7VEV
LCG1-DU0E-7VT9
PMKJ-BLB7-F4QM
2R51-N2A8-XPW5
*/

class GiftCodePurchaseForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      giftCode: '',
    };
  }

  handleChange = e => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = e => {
    const { giftCode } = this.state;
    e.preventDefault();

    // Within the context of `Elements`, this call to createToken knows which Element to
    // tokenize, since there's only one in this group.
    Log.info(`Got code ${giftCode}`, 'GiftCode Purchase Form');
    this.props.onSubmitGiftCode({
      code: giftCode,
    });
  }

  render() {
    const { error, working } = this.props;
    const {
      giftCode,
    } = this.state;

    const isInvalid = giftCode === '';

    Log.info(error, 'GiftCode Purchase Form:render');
    return (
      <Form className="mt-3" onSubmit={this.handleSubmit}>
        <FormError error={error} />
        <Row>
          <FormGroup className="col-md-4">
            <Label for="giftCode">Enter Gift Code</Label>
            <Input
              type="text"
              className="input-text form-control"
              name="giftCode"
              id="giftCode"
              placeholder=""
              value={this.state.giftCode}
              onChange={this.handleChange}
            />
          </FormGroup>
        </Row>
        <FormFieldError error={error} field="code" />
        <Row>
          <FormGroup className="col-md-6 col-sm-12 col-xs-12 d-flex justify-content-sm-center justify-content-md-start">
            <Button size="large" className="" disabled={isInvalid || working} type="submit">Confirm Purchase</Button>
          </FormGroup>
        </Row>
      </Form>
    );
  }
}

GiftCodePurchaseForm.propTypes = {
  onSubmitGiftCode: PropTypes.func.isRequired,
  error: types.error,
  working: PropTypes.bool,
};

GiftCodePurchaseForm.defaultProps = {
  error: null,
  working: false,
};

export default injectStripe(GiftCodePurchaseForm);
